/**
 * @generated SignedSource<<5b0adb916598977dc19bd1aea5c08009>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
export type AskCopilotMessageRole = "ASSISTANT" | "USER";
import { FragmentRefs } from "relay-runtime";
export type AskFellowPanelInner_groupToolUsesWithResponse_message$data = {
  readonly content: string;
  readonly contentForDisplay: string | null;
  readonly contentJson: any | null;
  readonly id: string;
  readonly role: AskCopilotMessageRole;
  readonly " $fragmentType": "AskFellowPanelInner_groupToolUsesWithResponse_message";
};
export type AskFellowPanelInner_groupToolUsesWithResponse_message$key = {
  readonly " $data"?: AskFellowPanelInner_groupToolUsesWithResponse_message$data;
  readonly " $fragmentSpreads": FragmentRefs<"AskFellowPanelInner_groupToolUsesWithResponse_message">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "AskFellowPanelInner_groupToolUsesWithResponse_message"
};

(node as any).hash = "3bda34aee3dbe067e18df846a5929734";

export default node;
